export default __webpack_public_path__ + "static/media/webComponent_blog.62541e39.jfif";